const BASE_URL = 'https://finale-backend.baobabchallenge.com/api';
const BASE_IMAGE_URL = 'https://finale-backend.baobabchallenge.com/images';
// const BASE_URL = 'http://localhost:8000/api';
// const BASE_IMAGE_URL = 'http://localhost:8000/images';

export default {
  BASE_URL,
  BASE_IMAGE_URL,
  // API Endpoints
  getJuries: `${BASE_URL}/getJuries`,
  getCandidates: `${BASE_URL}/getCandidates`,
  getCriterias: `${BASE_URL}/getCriterias`,
  getCriteriasByCategory: `${BASE_URL}/getCriteriasByCategory`,
  getEvaluations: `${BASE_URL}/getEvaluations`,
  submitEvaluation: `${BASE_URL}/submitEvaluation`,
  getCandidateRatingsByJury: `${BASE_URL}/getCandidateRatingsByJury`,
  getGeneralResults: `${BASE_URL}/getGeneralResults`,
  getWinner: `${BASE_URL}/getWinner`,
  getEvaluationByJury: (id) => `${BASE_URL}/getEvaluationByJury/${id}`,
  getEvaluationByCandidate: (id) => `${BASE_URL}/getEvaluationByCandidate/${id}`,
  getEvaluationByCriteria: (id) => `${BASE_URL}/getEvaluationByCriteria/${id}`,

  // Jury Authentication Endpoints
  juryLogin: `${BASE_URL}/jury/login`,
  juryLogout: `${BASE_URL}/jury/logout`,
  juryForgotPassword: `${BASE_URL}/jury/forgot-password`,
  juryResetPassword: `${BASE_URL}/jury/reset-password`,
  juryMe: `${BASE_URL}/jury/me`,
  juryUpdateProfile: `${BASE_URL}/jury/update-profile`,

  // Image URL Utility Functions
  getJuryImageUrl: (filename) => `${BASE_IMAGE_URL}/juries/${filename}`,
  getCandidateImageUrl: (filename) => `${BASE_IMAGE_URL}/candidates/${filename}`
};